var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventMenuDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21539_1454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10C6 8.1144 6 7.1716 6.58579 6.58579C7.1716 6 8.1144 6 10 6H10.6667C12.5523 6 13.4951 6 14.0809 6.58579C14.6667 7.1716 14.6667 8.1144 14.6667 10V10.6667C14.6667 12.5523 14.6667 13.4951 14.0809 14.0809C13.4951 14.6667 12.5523 14.6667 10.6667 14.6667H10C8.1144 14.6667 7.1716 14.6667 6.58579 14.0809C6 13.4951 6 12.5523 6 10.6667V10Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 5.99967C11.3316 4.02828 11.3018 3.00715 10.7279 2.30796C10.6171 2.17293 10.4933 2.04913 10.3583 1.93831C9.62072 1.33301 8.52492 1.33301 6.33325 1.33301C4.1416 1.33301 3.04577 1.33301 2.30821 1.93831C2.17318 2.04912 2.04937 2.17293 1.93856 2.30796C1.33325 3.04553 1.33325 4.14135 1.33325 6.33301C1.33325 8.52467 1.33325 9.62047 1.93856 10.3581C2.04937 10.4931 2.17318 10.6169 2.30821 10.7277C3.00739 11.3015 4.02853 11.3313 5.99992 11.3329",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21539_1454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventMenuDuplicate);
export default __webpack_public_path__ + "static/media/event_menu_duplicate.a984b990b05fa333ddfef1638165be0b.svg";
export { ForwardRef as ReactComponent };